export default __webpack_public_path__ + "static/Magazin 20 Jahrhundert_02-6594ae1bf83322788e3d0716710e52f6.jpg";